class GamaTalleres {
  constructor(section) {
    this.section = section;
    this.container = section.querySelector('.gama-talleres__container');
    this.slides = Array.from(section.querySelectorAll('.gama-talleres__slide'));
    this.prev = section.querySelector('[data-gama-prev]');
    this.next = section.querySelector('[data-gama-next]');
    this.index = 0;

    this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
    this.next?.addEventListener('click', () => this.goTo(this.index + 1));

    window.addEventListener('resize', () => this.goTo(this.index));
  }

  goTo(index) {
    if (!this.slides.length) return;

    this.index = Math.max(0, Math.min(index, this.slides.length - 1));
    const slideWidth = this.slides[0].getBoundingClientRect().width;

    this.container.style.transform = `translateX(-${slideWidth * this.index}px)`;
    this.container.style.transition = 'transform .35s ease';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gama-talleres]').forEach(section => {
    new GamaTalleres(section);
  });
});